import config from 'config';

// TODO: move to local component utils when cleaning up FF
import {
  getCioSortOrder,
  getPreFilterExpressions,
  getSanitizedFilterInputsForCio,
  isolateSizeFilters,
} from '~/grid/utils/cioUtils';

import { BROWSE_API_PAGE_SIZE } from '../constants';

/**
 * @function getCioBrowseResults
 * @description Fetches browse results from Constructor.io's browse API
 * @param {Object} cioClient - Constructor.io client instance
 * @param {String} cioFilterName - Filter name {'collection_id' | 'category_id' | <facet_name>}
 * @param {String} cioFilterValue - Filter value e.g. 'womens-bottoms'
 * @param {Boolean} isElite - Is the user an elite member
 * @param {Boolean} isVip - Is the user a VIP member
 * @param {Number} page - Page number for pagination
 * @param {Array} selectedUrlFilters - Array of selected filters from the URL
 * @param {String} selectedSortOption - Selected sort option
 * @param {String} tld - Top-level domain
 * @param {Boolean} removeOriginFlag - Flag to remove origin restricted products
 * @param {Boolean} isSecondarySite - Flag to indicate if the site is secondary
 * @param {Boolean} isSaleGrid - Flag to indicate if the grid is a sale grid
 * @return {Object} Browse results
 */
const getCioBrowseResults = async ({
  cioClient,
  cioFilterName,
  cioFilterValue,
  isElite = false,
  isVip = false,
  page = 1,
  selectedUrlFilters,
  selectedSortOption,
  tld = 'com',
  removeOriginFlag = false,
  isSecondarySite = false,
  isSaleGrid = false,
}) => {
  const staticCurrentDate = new Date();
  const hiddenFacets = config.get('public.brand.constructor.hiddenFacets');

  const { sizeFilters, nonSizeFilters } =
    isolateSizeFilters(selectedUrlFilters);

  const results = await cioClient.browse.getBrowseResults(
    cioFilterName,
    cioFilterValue,
    {
      resultsPerPage: BROWSE_API_PAGE_SIZE,
      page,
      preFilterExpression: getPreFilterExpressions({
        isElite,
        isVip,
        dateNowInMs: staticCurrentDate.getTime(),
        shouldShowWarehouseProducts: isSecondarySite,
        shouldHideOriginRestricted: removeOriginFlag,
        selectedSizeFilters: sizeFilters,
        tld,
        autoExcludeClearanceFplIds: !isSaleGrid,
      }),
      filters: getSanitizedFilterInputsForCio(nonSizeFilters),
      sortBy: selectedSortOption,
      sortOrder: getCioSortOrder(selectedSortOption),
      hiddenFacets,
    }
  );

  const hasNextPage =
    page * BROWSE_API_PAGE_SIZE < results?.response?.total_num_results;
  const nextPage = hasNextPage ? page + 1 : null;
  const totalNumResults = results?.response?.total_num_results;

  return { ...results, nextPage, totalNumResults };
};

export default getCioBrowseResults;
